module.exports = __webpack_public_path__ + "img/icon-zoom-in.578915fb.svg";